import { createTheme } from '@material-ui/core/styles';

//Main Green
const mainGreen1 = '#e4f2ee';
const mainGreen2 = '#d8e6e2';
const mainGreen3 = '#abd9d0';
const mainGreen4 = '#81ccbf';
const mainGreen5 = '#5abfb2';
const mainGreen6 = '#38b2a6';
const mainGreen7 = '#248c85';
const mainGreen8 = '#156663';
const mainGreen9 = '#0a4040';
const mainGreen10 = '#04191a';
//Yellow
const yellow1 = '#ffffe6';
const yellow2 = '#fffaa3';
const yellow3 = '#fff47a';
const yellow4 = '#ffeb52';
const yellow5 = '#ffdf29';
const yellow6 = '#fcce01';
const yellow7 = '#d6a800';
const yellow8 = '#b08400';
const yellow9 = '#8a6300';
const yellow10 = '#634400';
//Gray
const gray1 = '#ffffff';
const gray2 = '#fafafa';
const gray3 = '#f5f5f5';
const gray4 = '#e8e8e8';
const gray5 = '#d9d9d9';
const gray6 = '#bfbfbf';
const gray7 = '#8c8c8c';
const gray8 = '#595959';
const gray9 = '#252525';
const gray10 = '#000000';
const gray11 = '#63656a';
//Red
const red1 = '#fff2e6';
const red2 = '#ffcfa6';
const red3 = '#ffb57d';
const red4 = '#ff9854';
const red5 = '#ff792b';
const red6 = '#f25202';
const red7 = '#cc3d00';
const red8 = '#a62c00';
const red9 = '#801e00';
const red10 = '#591200';
const red11 = '#f5222d';
//Orange
const orange1 = '#fffbe6';
const orange2 = '#ffeda3';
const orange3 = '#ffe07a';
const orange4 = '#ffd15a';
const orange5 = '#ffbf29';
const orange6 = '#f9a600';
const orange7 = '#d48600';
const orange8 = '#ad6800';
const orange9 = '#874d00';
const orange10 = '#613400';
const orange11 = '#faad14';
//Green
const green1 = '#f0fff3';
const green2 = '#e9f7ec';
const green3 = '#b7ebc6';
const green4 = '#8adea4';
const green5 = '#60d188';
const green6 = '#3bc56f';
const green7 = '#289e59';
const green8 = '#187843';
const green9 = '#0c522e';
const green10 = '#062b19';
const green11 = '#52c41a';
//Blue
const blue1 = '#f0f7ff';
const blue2 = '#f0f6ff';
const blue3 = '#ebf2ff';
const blue4 = '#c2d7ff';
const blue5 = '#99b9ff';
const blue6 = '#6b92f3';
const blue7 = '#506fcc';
const blue8 = '#3850a6';
const blue9 = '#253680';
const blue10 = '#192359';

//fontColor
const titleColor = 'rgba(0, 0, 0, 0.85)';
const bodyColor = 'rgba(0, 0, 0, 0.65)';
const captionColor = 'rgba(0, 0, 0, 0.45)';
const disableColor = 'rgba(0, 0, 0, 0.25)';
const borderColor = 'rgba(0, 0, 0, 0.06)';

const mainRootPadding = '16px 32px';

const flex = {
  fill: {
    display: 'flex',
    flex: 1,
  },
  center: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  fillCenter: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
  },
  rowReverse: {
    display: 'flex',
    flexDirection: 'row-reverse',
  },
  col: {
    display: 'flex',
    flexDirection: 'column',
  },
  colReverse: {
    display: 'flex',
    flexDirection: 'column-reverse',
  },
  mainStart: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  mainCenter: {
    display: 'flex',
    justifyContent: 'center',
  },
  mainEnd: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  mainSpaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  mainSpaceAround: {
    display: 'flex',
    justifyContent: 'space-around',
  },
  crossStart: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  crossCenter: {
    display: 'flex',
    alignItems: 'center',
  },
  crossEnd: {
    display: 'flex',
    alignItems: 'flex-end',
  },
  crossStretch: {
    display: 'flex',
    alignItems: 'stretch',
  },
  rowMain: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  rowCross: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  rowCenter: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  colMain: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  colCross: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  colCenter: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  fillRow: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
  fillRowReverse: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row-reverse',
  },
  fillRowMain: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  fillRowCross: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  fillRowCenter: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  fillCol: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
  fillColReverse: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column-reverse',
  },
  fillColMain: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
  },
  fillColCross: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
  },
  fillColCenter: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

const theme = createTheme({
  breakpoints: {
    keys: ['xs', 'sm', 'md', 'lg', 'xl'],
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },

  typography: {
    fontFamilySmall: '"SF UI Text", sans-serif',
    fontFamilyLarge: '"SF UI Display", sans-serif',
    fontFamily: ['Avenir Next W04', 'Avenir Next', '"Helvetica"', 'Arial', 'sans-serif'].join(','),
    h1: {
      fontSize: 30,
      lineHeight: '38px',
      fontWeight: '600',
      fontFamily: '"SF UI Text", sans-serif',
      letterSpacing: 'normal',
    },
    h2: {
      fontSize: 24,
      lineHeight: '32px',
      fontWeight: '600',
      fontFamily: '"SF UI Text", sans-serif',
      letterSpacing: 'normal',
    },
    h3: {
      fontSize: 20,
      lineHeight: '24px',
      fontWeight: '600',
      fontFamily: '"SF UI Text", sans-serif',
      letterSpacing: 'normal',
    },
    h4: {
      fontSize: 16,
      lineHeight: '24px',
      fontWeight: '600',
      fontFamily: '"SF UI Text", sans-serif',
      letterSpacing: 'normal',
    },
    h5: {
      fontSize: 14,
      lineHeight: '22px',
      fontWeight: '600',
      fontFamily: '"SF UI Text", sans-serif',
      letterSpacing: 'normal',
    },
    body1: {
      fontSize: 16,
      lineHeight: '24px',
      fontFamily: '"SF UI Text", sans-serif',
      letterSpacing: 'normal',
    },
    body2: {
      fontSize: 14,
      lineHeight: '22px',
      fontFamily: '"SF UI Text", sans-serif',
      letterSpacing: 'normal',
    },
    body3: {
      fontSize: 14,
      lineHeight: '22px',
      fontFamily: '"SF UI Text", sans-serif',
      fontWeight: '600',
      letterSpacing: 'normal',
    },
    body4: {
      fontSize: 12,
      lineHeight: '22px',
      fontFamily: '"SF UI Text", sans-serif',
      letterSpacing: 'normal',
    },
    body5: {
      fontSize: 12,
      lineHeight: '20px',
      fontFamily: '"SF UI Text", sans-serif',
      letterSpacing: 'normal',
    },
    body6: {
      fontSize: 12,
      lineHeight: '18px',
      fontFamily: '"SF UI Text", sans-serif',
      letterSpacing: 'normal',
    },
    button: {
      fontSize: 14,
      lineHeight: '24px',
      textTransform: 'none',
      letterSpacing: 'normal',
      fontWeight: 'bold',
      fontFamily: '"SF UI Text", sans-serif',
    },
    caption: {
      fontSize: 10,
      lineHeight: '16px',
      fontFamily: '"SF UI Text", sans-serif',
      letterSpacing: 'normal',
    },
    dropdown: { fontSize: 14, lineHeight: '20px', fontFamily: '"SF UI Text", sans-serif' },
  },

  mainRootPadding,

  colors: {
    mainGreen1,
    mainGreen2,
    mainGreen3,
    mainGreen4,
    mainGreen5,
    mainGreen6,
    mainGreen7,
    mainGreen8,
    mainGreen9,
    mainGreen10,
    yellow1,
    yellow2,
    yellow3,
    yellow4,
    yellow5,
    yellow6,
    yellow7,
    yellow8,
    yellow9,
    yellow10,
    gray1,
    gray2,
    gray3,
    gray4,
    gray5,
    gray6,
    gray7,
    gray8,
    gray9,
    gray10,
    gray11,
    red1,
    red2,
    red3,
    red4,
    red5,
    red6,
    red7,
    red8,
    red9,
    red10,
    red11,
    orange1,
    orange2,
    orange3,
    orange4,
    orange5,
    orange6,
    orange7,
    orange8,
    orange9,
    orange10,
    orange11,
    green1,
    green2,
    green3,
    green4,
    green5,
    green6,
    green7,
    green8,
    green9,
    green10,
    green11,
    blue1,
    blue2,
    blue3,
    blue4,
    blue5,
    blue6,
    blue7,
    blue8,
    blue9,
    blue10,
    titleColor,
    bodyColor,
    captionColor,
    disableColor,
    borderColor,
  },

  borderRadius: {
    min: 2,
    small: 4,
    big: 8,
    huge: 10,
    full: 9999,
  },

  divider: {
    dividerTop: '0 1px 0 0 rgba(0, 0, 0, 0.09)',
    dividerLeft: '1 0 0 0 rgba(0, 0, 0, 0.09)',
    dividerBottom: '0 1px 0 0 rgba(0, 0, 0, 0.09)',
    dividerRight: '-1 0 0 0 rgba(0, 0, 0, 0.09)',
    dividerNoBottom:
      'inset -1 0px 0 rgba(0, 0, 0, 0.09), inset 1 0px 0 rgba(0, 0, 0, 0.09), inset 0 1px 0 rgba(0, 0, 0, 0.09)',
    dividerNoLeft:
      'inset -1 0px 0 rgba(0, 0, 0, 0.09), inset 1 0px 0 rgba(0, 0, 0, 0.09), inset 0 1px 0 rgba(0, 0, 0, 0.09)',
    dividerTopAndLeft:
      'inset 0 -1px 0 rgba(0, 0, 0, 0.09), inset -1 0px 0 rgba(0, 0, 0, 0.09), inset 0 1px 0 rgba(0, 0, 0, 0.09)',
    dividerTopAndRight:
      'inset 0 -1px 0 rgba(0, 0, 0, 0.09), inset 0 1px 0 rgba(0, 0, 0, 0.09), inset 1 0px 0 rgba(0, 0, 0, 0.09)',
  },

  shadow: {
    main: '0 2px 16px 0 rgba(51, 53, 50, 0.08)',
    modal:
      '0px 3px 6px -4px rgba(0, 0, 0, 0.12), 0px 6px 16px rgba(0, 0, 0, 0.08), 0px 9px 28px 8px rgba(0, 0, 0, 0.05)',
    componentDark: '0 2px 8px 0 rgba(51, 53, 50, 0.16)',
    componentShallow: '0 4px 8px 0 rgba(51, 53, 50, 0.08)',
    brandActionShallow: '0 0 4px 0 rgba(69, 87, 161, 0.64)',
    btn: '0px 2px 0px rgba(0, 0, 0, 0.016)',
  },

  flex,

  singleLineOverflow: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
});

export default theme;
